import { useState } from 'react';
import { createBrick } from '../../http/brickAPI';

function BricksPOST() {
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [price, setPrice] = useState('')
    const [isRegular, setIsRegular] = useState('Обычный')
    const [type, setType] = useState('1 НФ')
    const [image, setImage] = useState(null)
    const [secondImage, setSecondImage] = useState(null)
    const [thirdImage, setThirdImage] = useState(null)
    const [video, setVideo] = useState(null)

    const handleFileChange = (setter) => (e) => {
        setter(e.target.files[0])
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        
        try {
            const formData = new FormData()
            formData.append('name', name)
            formData.append('description', description)
            formData.append('price', price)
            formData.append('is_regular', isRegular)
            formData.append('type', type)
            if (image) formData.append('image', image)
            if (secondImage) formData.append('second_image', secondImage)
            if (thirdImage) formData.append('third_image', thirdImage)
            if (video) formData.append('video', video)
            await createBrick(formData)
            setName('')
            setDescription('')
            setPrice('')
            setIsRegular('Обычный')
            setType('1 НФ')
            setImage(null)
            setSecondImage(null)
            setThirdImage(null)
            setVideo(null)
            
            alert('Товар успешно добавлен!')
        } catch (error) {
            console.error('Ошибка при добавлении товара:', error)
            alert('Произошла ошибка при добавлении товара')
        }
    }

    return (
        <div className='centered' style={{width:'100%'}}>
            <div className='card-container' style={{flexDirection:'column',width:'100%'}}>
                <h1>Добавить новый товар</h1>
                <form onSubmit={handleSubmit}>
                    <ul>
                        <li>
                            <input 
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Введите название" 
                                id='NEWCARD-INPUT'
                                required
                            />
                        </li>
                        <li>
                            1 Картинка:
                            <div className="file-input-container">
                                <input 
                                    onChange={handleFileChange(setImage)}
                                    type="file"
                                    name="image"
                                    accept="image/*"
                                />
                            </div>
                        </li>
                        <li>
                            2 Картинка:
                                <input 
                                    onChange={handleFileChange(setSecondImage)}
                                    type="file"
                                    name="second_image"
                                    accept="image/*"
                                />
                        </li>
                        <li>
                            3 Картинка:
                                <input 
                                    onChange={handleFileChange(setThirdImage)}
                                    type="file"
                                    name="third_image"
                                    accept="image/*"
                                />
                        </li>
                        <li>
                            Видео:
                                <input 
                                    onChange={handleFileChange(setVideo)}
                                    type="file"
                                    name="video"
                                    accept="video/*"
                                />
                        </li>
                        <li>
                            <textarea 
                                style={{margin:'2% 0px'}}
                                placeholder="Введите описание" 
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                required
                            />
                        </li>
                        <li>
                            <select 
                                style={{margin:'2% 0px'}}
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                required
                            >
                                <option value="1 НФ">1 НФ</option>
                                <option value="1.4 НФ">1.4 НФ</option>
                            </select>
                        </li>
                        <li>
                            <input 
                                style={{margin:'2% 0px'}}
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                                placeholder="Введите цену" 
                                id='NEWCARD-INPUT'
                                type="number"
                                required
                            />
                        </li>
                        <li>
                            <label>
                                Обычный  
                                <input 
                                    type="radio" 
                                    name="isRegular" 
                                    value="Обычный" 
                                    checked={isRegular === 'Обычный'}
                                    onChange={() => setIsRegular('Обычный')}
                                />
                            </label>
                        </li>
                        <li>
                            <label>
                                Миксовый  
                                <input 
                                    style={{margin:'2% 0px'}}
                                    type="radio" 
                                    name="isRegular" 
                                    value="Миксовый" 
                                    checked={isRegular === 'Миксовый'}
                                    onChange={() => setIsRegular('Миксовый')}
                                />
                            </label>
                        </li>
                        <li>
                            <button type="submit" className="blue-btn" >Подтвердить</button>
                        </li>
                    </ul>
                </form>
            </div>
        </div>
    );
}

export default BricksPOST;